import styles from "./StoreIndicator.module.scss";
import { StoreRegion } from "@/lib/builder/builder.config";
import clsx from "clsx";

interface StoreIndicatorProps {
	store: StoreRegion;
	lang: string;
	onClickHandler: () => void;
}

const StoreIndicator = ({
	store,
	lang,
	onClickHandler,
}: StoreIndicatorProps) => {
	return (
		<div className={styles.indicatorContainer}>
			<button
				onClick={onClickHandler}
				type={"button"}
				className={styles.button}
				aria-label=''
			>
				{selectRegionIcon(store)}{" "}
				<span className={styles.lang}>{lang.toUpperCase()}</span>
			</button>
		</div>
	);
};

export default StoreIndicator;

// Map store to icon
// Use Record<StoreRegion, JSX.Element> if you want to constrain the flags to existing regions
const storeToFlagSelector: Record<string, JSX.Element | undefined> = {
	global: undefined,
	ca: <RegionIcon alpha2Code='ca' />,
	us: <RegionIcon alpha2Code='us' />,
	eu: <RegionIcon alpha2Code='eu' />,
	au: <RegionIcon alpha2Code='au' />,
	nz: <RegionIcon alpha2Code='nz' />,
	jp: <RegionIcon alpha2Code='jp' />,
};

function selectRegionIcon(store: StoreRegion) {
	return storeToFlagSelector[store];
}
// Flags originate from https://flagicons.lipis.dev/
function RegionIcon({ alpha2Code }: { alpha2Code: string }) {
	return <span className={clsx("fi", `fi-${alpha2Code}`, styles.flag)}></span>;
}
